import './style.scss'

import {
  Layout,
  Page,
  Banner,
  Badge
} from "@shopify/polaris";

import Plan from './Plan'
import Sections from './Sections'

function Settings() {

  return (
    <Page title="Settings" backAction={{ content: 'Guide', url: '/' }}>
      <Layout>
        <Plan />
        <Sections />
        <Layout.AnnotatedSection
          title="Mentions"
          description="Link to articles in your guide and resources in Shopify admin using mentions."
        >
          <table className="AC-Mention-Table">
            <tbody>
              <tr><td><b>#</b></td><td><b>[article name]</b> - another article in your Handbook</td></tr>
              <tr><td><b>@</b></td><td><b>[page name]</b> - a page in your store</td></tr>
            </tbody>
          </table>
          <Banner title="Hint" tone="info">
            <p>To mention an article or resource, start typing the mention character followed by it's name. For example:</p>
            <p style={{ marginTop: '4px' }}>To link the article <b>Getting Started</b>, start typing <Badge>#gett</Badge> and select from suggestions</p>
            <p style={{ marginTop: '4px' }}>To link the page <b>About Us</b>, start typing <Badge>@</Badge> and select from suggestions</p>

          </Banner>
        </Layout.AnnotatedSection>
      </Layout>
    </Page>

  )
}

export default Settings;
